import { render, staticRenderFns } from "./ChatUserCard.vue?vue&type=template&id=8608d6a2&lang=pug&"
import script from "./ChatUserCard.vue?vue&type=script&lang=js&"
export * from "./ChatUserCard.vue?vue&type=script&lang=js&"
import style0 from "./ChatUserCard.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports